/**
 * News Block.
 * 
 */

/* global Alpine */

function initNewsItems() {
	// console.log("NEWS: initNewsItems()");

	let
		$newsItems = $('.news-items'),
		newsItemsH = 0,
		hashCategory = window.location.hash.substr(1);

	Alpine.data('newsBlockComponent', () => ({
		// Function init() fades in news items.
		init() {
			// console.log("NEWS: newsBlockComponent: init(): "+hashCategory);

			const myref = this;
			$(window).on('hashchange', function(e){
				hashCategory = window.location.hash.substr(1);
				myref.checkHash();
			});

			// If url has anchor tag...
			// Set filter category to tag &
			// Set filter  UI to highlight tag.
			if (hashCategory) {
				this.setCategory(hashCategory);
				setNewsFilter(hashCategory);
			}

			// this.newsItems = this.shuffle(newsItems);	// Randomize items.
			this.newsItems = newsItems;					// No randomization.
			this.fadeIn();
		},

		checkHash() {
			if (hashCategory) {
				this.setCategory(hashCategory);
				setNewsFilter(hashCategory);
			}		
		},

		// Function fadeIn() sets .news-items to invisible, then transitions to visible in .1s.
		fadeIn() {
			// console.log("NEWS: fadeIn()");
			this.visible = false;
			setTimeout(() => {
				this.visible = true;
			}, 100);
			setTimeout(() => {								// Preserve news item list height.
				$newsItems.css('height', 'fit-content');	// Set to 'fit-content' to measure height based on contents.
				newsItemsH = $newsItems.outerHeight();		// Get resulting height (includes padding).
				$newsItems.css('height', newsItemsH+'px');	// Set to resulting height.
			}, 200);
			// setTimeout(()=> {								// Is this necessary? Added to setGridHeight() in news-block.js.
			// 	ScrollTrigger.refresh();
			// }, 1000);
		},
	
		// .news-items is visible.
		visible: true,
		// .news-items displays page 1.
		page: 1,
		// .news-items displays 5 items per page.
		count: 5,
		// .news-items is initially NOT filtered.
		category: null,
		// .news-items max pages is initially NOT defined.
		maxPages: null,

		pageH: null,
	
		// Function filteredItems()...
		filteredItems() {
			// console.log("NEWS: filteredItems()");
			// Create/populate 'filteredList'.
			// if a filter category is selected, return filter items for that category...
			// if not, return all items.
			const filteredList = this.category 
			? this.newsItems.filter((item) => {
				return item.categorySlug.includes(this.category);
				})
			: this.newsItems;
			// 'listLength' = how many items in filteredList?
			const listLength = filteredList.length;
			// Update 'maxPages' = #items / #items per page.
			this.maxPages = Math.ceil(listLength / this.count);
			// 'start' is index of first item on current page.
			// 'end' is index of last item on current page.
			// Calculate 'start'.
			const start = ((this.page - 1) * this.count);
			// If #items > the index of last item of currently displayed(?) page...
			// (We are not on the last page of filtered items)
			// 'end' is 'start' + #items per page.
			// If not...
			// (We ARE on the last page of filtered items)
			// 'end' is the total #items.
			const end = listLength > start + this.count 
			? start + this.count
			: listLength;

			// Function returns array of items to display on current page.
			this.setListHeight();	// setListHeight().
			return filteredList.slice(start, end);
		},
	
		setListHeight() {			// setListHeight().
			// console.log("NEWS: setListHeight()");

			this.$nextTick(() => {
				// Grab current (old height)
				const oldHeight = this.$refs.list.style.height;
				// Calculate new height (need to disable transition)
				this.$refs.list.style.transitionDuration = '0s';
				this.$refs.list.style.height = null;
				const newHeight = `${this.$refs.list.offsetHeight}px`;
				// Set height to old height, to allow for CSS height transition
				this.$refs.list.style.height = oldHeight;
				setTimeout(() => {
					// Set new height after a beat...
					this.$refs.list.style.transitionDuration = '300ms';
					this.$refs.list.style.height = newHeight;
				}, 10);
			});
		},
		
		// Function setCategory()...
		setCategory(categorySelection) {
			// A filter has been selected. Update filter category.
			// Display page 1 of newly filtered items.
			this.category = categorySelection;
			this.page = 1;
			this.fadeIn();

			// Update browser URL without reloading page or affecting history.
			if (categorySelection) {
				history.replaceState('', 'News', '/news/#'+categorySelection);
			} else {
				history.replaceState('', 'News', '/news/');
			}
		},
	
		prev() {
			if (this.page > 1) {
				this.page--;
				this.fadeIn();
			}
		},
	
		next() {
			if (this.page < this.maxPages) {
				this.page++;
				this.fadeIn();
			}
		},
	
		shuffle(array) { 
			for (let i = array.length - 1; i > 0; i--) { 
			const j = Math.floor(Math.random() * (i + 1)); 
			[array[i], array[j]] = [array[j], array[i]]; 
			} 
			return array; 
		}
	}));

}

/**
 * Team Filter UI.
 * Mobile: Dropdown/expand-collapse filter panel.
 * Desktop: Same as mobile.
 */

function setNewsFilter(myFilter) {
	// console.log('NEWS: setNewsFilter(): '+myFilter);

	let
		$excolBtn = $('.team-block__filter-selected'),
		$selectedFilterMobile = $('.team-block__filter-term-selected'),
		$filterPanelMobile = $('.filter__panel-container'),
		$filterBtnsMobile = $('.filter__panel-link'),
		$filterBtnsDesktop = $('.team-block__filter-term'),
		$myBtnDesktop = $filterBtnsDesktop.filter('[data-filter=' + myFilter + ']'),
		$myBtnMobile = $filterBtnsMobile.filter('[data-filter=' + myFilter + ']');

	// Deactivate all buttons.
	$filterBtnsMobile.removeClass('active');
	$filterBtnsDesktop.removeClass('active');
	// Activate desktop filter button.
	// $myBtnDesktop.addClass('active');
	// Activate mobile filter button.
	$myBtnMobile.addClass('active');
	$excolBtn.removeClass('is-active');
	$filterPanelMobile.removeClass('is-active');
	$selectedFilterMobile.html($myBtnMobile.html());
	// $filterBtnsDesktop.html($myBtnDesktop.html());
};

function initNewsFilter() {
	// console.log("NEWS: initNewsFilter()");

	let
		$excolBtn = $('.team-block__filter-selected'),
		$selectedFilterMobile = $('.team-block__filter-term-selected'),
		$filterPanelMobile = $('.filter__panel-container'),
		$filterBtnsMobile = $('.filter__panel-link'),
		$filterBtnsDesktop = $('.team-block__filter-term'),
		$myBtn,
		$myBtnDesktop;

	$excolBtn.on('click', function() {
		// console.log("NEWS: initNewsFilter(): CLICK");
		if (!$(this).hasClass('is-active')) {
			// Expand filter panel.
			// $filterPanel.fadeIn(300);
			$(this).addClass('is-active');
			$filterPanelMobile.addClass('is-active');
		} else {
			// $filterPanel.fadeOut(300);
			$(this).removeClass('is-active');
			$filterPanelMobile.removeClass('is-active');
		}
	});

	$filterBtnsMobile.on('click', function(event) {
		event.preventDefault();
		$myBtn = $(this);
		if (!$myBtn.hasClass('active')) {
			// Make button active.
			$filterBtnsMobile.removeClass('active');
			$filterBtnsDesktop.removeClass('active');
			$myBtn.addClass('active');
			$filterBtnsDesktop.removeClass('active');
			$myBtnDesktop = $filterBtnsDesktop.filter('[data-filter=' + $(this).data('filter') + ']');
			$myBtnDesktop.addClass('active');
			$excolBtn.removeClass('is-active');
			$filterPanelMobile.removeClass('is-active');
			$selectedFilterMobile.html($myBtn.html());
		}
	});
}

exports.init = function () {
	// console.log('NEWS: exports.init');
	// Run init methods...

	initNewsFilter();
	document.addEventListener('alpine:init', () => {
		initNewsItems();
	});
};